import { trackHelpEvent } from 'actions/tracker/tracker';
import { useFlysiteUrls } from 'hooks/useFlysiteUrls';
import type { MouseEventHandler } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentLocale } from 'selectors/ui/ui';
import { useDispatch } from 'store/configureStore';
import { useTranslations } from 'utils/translations/useTranslations';

type HelpProps = {
  onClick?: MouseEventHandler<HTMLAnchorElement>;
};

const Help = ({ onClick }: HelpProps) => {
  const i18n = useTranslations();
  const dispatch = useDispatch();
  const locale = useSelector(getCurrentLocale);
  const { supportUrl } = useFlysiteUrls(locale);

  const handleClick: MouseEventHandler<HTMLAnchorElement> = evt => {
    dispatch(trackHelpEvent());
    onClick?.(evt);
  };

  return (
    <a
      href={supportUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      data-testid="HelpLink"
    >
      {i18n.t('step.aside.help')}
    </a>
  );
};

export { Help };
